export default "__VITE_ASSET__DGHiJZqm__"